import { render, staticRenderFns } from "./AddressPanel.vue?vue&type=template&id=6bd13f4b&scoped=true&lang=pug&"
import script from "./AddressPanel.vue?vue&type=script&lang=js&"
export * from "./AddressPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddressPanel.vue?vue&type=style&index=0&id=6bd13f4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd13f4b",
  null
  
)

export default component.exports